(ns pfo.bulk.model (:require
                      [clojure.string :refer [trim replace]]
                      [pfo.api :as api]
                      [pfo.util :as util :refer [to-value bool-param]]))

(defn bulk-operations [group-id page]
  (api/ajaxp (str "/bulk/operations/") {:params (util/remove-nil-values
                                                  {:group_id group-id
                                                   :page page})}))

(defn bulk-operation [group-id operation-id]
  (api/ajaxp (str "/bulk/operation/") {:params {:group_id group-id
                                                :id operation-id}}))

(defn bulk-edit-items [bulk-edit-id page-number]
  (api/ajaxp (str "/groupadmin/bulkedits/" bulk-edit-id "/items/")
             {:params {:page page-number}}))

(defn bulk-apply-items [group-id operation-id page-number]
  (api/ajaxp (str "/bulk/apply/items/")
             {:params {:page page-number
                       :group_id group-id
                       :id operation-id}}))
